import React, { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Breadcrumb } from '@/components/layout/Breadcrumb'
import { PageHeader } from '@/components/layout/PageHeader'
import {
  closeProductionApi,
  getExecutionApi,
  getProductionOrderByIdApi,
  getProductionRequirementApi,
  issueProductionMaterialApi,
  listProductionMakeupsApi,
  recordCompletionApi,
  requestMakeupApi,
  reserveMakeupAvailableApi,
  startProductionApi,
} from '@/services/productionOrders'
import {
  createExecutionController,
  type ExecutionApi,
  type ExecutionSnapshot,
} from './executionController'
import { ProductionExecutionView } from './ProductionExecutionView'

export const liveExecutionApi: ExecutionApi = {
  getOrder: getProductionOrderByIdApi,
  getExecution: getExecutionApi,
  start: startProductionApi,
  recordCompletion: recordCompletionApi,
  getRequirement: getProductionRequirementApi,
  listMakeups: listProductionMakeupsApi,
  requestMakeup: requestMakeupApi,
  reserveMakeup: reserveMakeupAvailableApi,
  issue: (id, payload, key) => issueProductionMaterialApi(id, payload, key),
  close: closeProductionApi,
}

export function ProductionExecutionPage(): React.ReactElement {
  const { id = '' } = useParams<{ id: string }>()
  const [snapshot, setSnapshot] = useState<ExecutionSnapshot | null>(null)

  const ctrl = useMemo(() => createExecutionController(id, liveExecutionApi, setSnapshot), [id])

  useEffect(() => {
    void ctrl.load()
  }, [ctrl])

  const snap = snapshot ?? ctrl.getSnapshot()

  return (
    <div>
      <Breadcrumb
        items={[
          { label: 'Kế hoạch', to: '/planning' },
          { label: 'Lệnh sản xuất', to: '/planning/production-orders' },
          { label: 'Thực hiện sản xuất' },
        ]}
      />
      <PageHeader title="Thực hiện sản xuất" subtitle="Hoàn thành, bổ sung vật tư và đóng lệnh sản xuất" />
      <ProductionExecutionView
        snapshot={snap}
        onRetry={() => void ctrl.load()}
        onStart={() => void ctrl.start()}
        onSubmitCompletion={(q) => void ctrl.submitCompletion(q)}
        onRequestMakeup={(i) => void ctrl.requestMakeup(i)}
        onReserveMakeup={(rid) => void ctrl.reserveMakeup(rid)}
        onIssue={(lines) => void ctrl.issue(lines)}
        onClose={() => void ctrl.close()}
      />
    </div>
  )
}
